module.exports = __webpack_public_path__ + "img/symbol_4.ace8bdac.png";